import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { MainLayout } from '@/components/layout/MainLayout'
import { TermsOfUseContent, PrivacyPolicyContent } from '@adthlete/shared-frontend'

const TermsAndConditions = () => {
  const navigate = useNavigate()

  return (
    <MainLayout>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="pb-4 max-w-4xl">
          <div className="flex items-center gap-4 mb-6">
            <Button
              onClick={() => navigate(-1)}
              variant="outline"
              size="sm"
              className="bg-card text-foreground border-foreground/10 hover:bg-foreground/10"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back
            </Button>
            <h1 className="text-3xl font-bold text-foreground">Terms and Conditions</h1>
          </div>

          <div className="space-y-6">
            <TermsOfUseContent maxHeight="h-128" />
            <PrivacyPolicyContent maxHeight="h-128" />
          </div>
        </div>
      </div>
    </MainLayout>
  )
}

export default TermsAndConditions
